var render, staticRenderFns
import script from "./MaxBidCreatedModal.vue?vue&type=script&lang=js"
export * from "./MaxBidCreatedModal.vue?vue&type=script&lang=js"
import style0 from "./MaxBidCreatedModal.vue?vue&type=style&index=0&id=7428eaae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports